import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    postLabSpecimenTypeSuccess, postLabSpecimenTypeFailure,
    getLabSpecimenTypeSuccess, getLabSpecimenTypeFailure,
    getLabSpecimenTypeByIdSuccess, getLabSpecimenTypeByIdFailure,
    putLabSpecimenTypeSuccess, putLabSpecimenTypeFailure,
    deleteLabSpecimenTypeSuccess, deleteLabSpecimenTypeFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* postRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimen-types`, requestDetail);
        yield put(postLabSpecimenTypeSuccess(response));
    } catch (error) {
        yield put(postLabSpecimenTypeFailure(error?.response?.message || error));
    }
}

function* getRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { page, limit, searchQuery } = action.payload || { page: 1, limit: null, searchQuery: "" };
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimen-types?page=${page}&limit=${limit}&searchQuery=${searchQuery}`, requestDetail);
        yield put(getLabSpecimenTypeSuccess(response));
    } catch (error) {
        yield put(getLabSpecimenTypeFailure(error?.response?.message || error));
    }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimen-types/${action.payload}`, requestDetail);
        yield put(getLabSpecimenTypeByIdSuccess(response));
    } catch (error) {
        yield put(getLabSpecimenTypeByIdFailure(error?.response?.message || error));
    }
}

function* putRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimen-types`, requestDetail);
        yield put(putLabSpecimenTypeSuccess(response));
    } catch (error) {
        yield put(putLabSpecimenTypeFailure(error?.response?.message || error));
    }
}

function* deleteRequest(action) {
    try {
        const requestDetail = {
            method: "DELETE",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimen-types/${action.payload}`, requestDetail);
        yield put(deleteLabSpecimenTypeSuccess(response));
    } catch (error) {
        yield put(deleteLabSpecimenTypeFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('labSpecimenType/postLabSpecimenTypeRequest', postRequest);
    yield takeLatest('labSpecimenType/getLabSpecimenTypeRequest', getRequest);
    yield takeLatest('labSpecimenType/getLabSpecimenTypeByIdRequest', getByIdRequest);
    yield takeLatest('labSpecimenType/putLabSpecimenTypeRequest', putRequest);
    yield takeLatest('labSpecimenType/deleteLabSpecimenTypeRequest', deleteRequest);
}

export default saga;
